import {
    CreateBase,
    TabbedForm,
    SaveButton,
    Toolbar,
} from 'react-admin';
import { Card, Box } from '@mui/material';

import { UserInputs } from './UserInputs';
import { UserCreditCardInputs } from './UserCreditCardInputs';
import { findDuplicateLastFour } from './userCreditCardValidation';

export const UserCreate = () => {
    const validateUserCreation = (values: any) => {
        const errors: { [key: string]: string } = {};
        if (!values.password) {
            errors.password = 'New password is required';
        }
        if (values.password && values.password !== values.confirm_password) {
            errors.confirm_password = 'The two passwords must match';
        }
        if (values.password && values.password.length < 8) {
            errors.password = 'Password must be at least 8 characters long';
        }
        if (values.password && values.password.length > 20) {
            errors.password = 'Password must be at most 20 characters long';
        }
        if (values.password && !/[0-9]/.test(values.password)) {
            errors.password = 'Password must contain at least one number';
        }
        if (values.password && !/[A-Z]/.test(values.password)) {
            errors.password = 'Password must contain at least one uppercase letter';
        }
        if (values.password && !/[a-zA-Z]/.test(values.password)) {
            errors.password = 'Password must contain at least one letter';
        }

        // Check for duplicate credit cards
        const duplicateCard = findDuplicateLastFour(values.credit_cards);
        if (duplicateCard) {
            errors.credit_cards = `Card ending ${duplicateCard} is duplicated in the list`;
        }

        return errors;
    };

    return (
        <CreateBase redirect="show">
            <Box mt={2} display="flex">
                <Box flex="1">
                    <Card>
                        {/* @ts-ignore */}
                        <TabbedForm
                            validate={validateUserCreation}
                            defaultValues={{
                                is_active: true,
                                is_superuser: false,
                                can_sign: false,
                                credit_cards: [],
                            }}
                            toolbar={
                                <Toolbar>
                                    <SaveButton />
                                </Toolbar>
                            }
                        >
                            <TabbedForm.Tab label="Basic Info">
                                <UserInputs />
                            </TabbedForm.Tab>
                            <TabbedForm.Tab label="Credit Cards" path="credit-cards">
                                <UserCreditCardInputs />
                            </TabbedForm.Tab>
                        </TabbedForm>
                    </Card>
                </Box>
            </Box>
        </CreateBase>
    );
};
